exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".firebase-container h1 {\r\n  font-size: 20pt;\r\n  display: none;\r\n}\r\n\r\n.firebase-container label {\r\n  font-size: 14pt;\r\n  font-weight: normal;\r\n  display: block;\r\n}\r\n.firebase-container input {\r\n  width: 40%;\r\n  height: 35px;\r\n  text-align: center;\r\n  font-size: 15pt;\r\n}\r\n.firebase-container button {\r\n  background-color: #4075b3;\r\n  color: white;\r\n  height: 75px;\r\n  width: 150px;\r\n  border-radius: 5px;\r\n  border: none;\r\n  font-size: 18pt;\r\n  margin: 0 5px 0 5px;\r\n}\r\n\r\n.user-login-button {\r\n  margin-bottom: 20px;\r\n}\r\n", ""]);

// exports
